import { type AddToCartEvent, addToCartEventSchema } from './eCommerceTrackingEventSchema';
import { getCatalogSourceTrackingData } from './catalogSourceStorage';
import logger from '../logger';

export type AddToCartEventProps = Omit<AddToCartEvent, 'event_name' | 'event'>;

export const buildAddToCartEvent = (props: AddToCartEventProps): AddToCartEvent => {
  const addToCartEvent: AddToCartEvent = {
    event: 'ga4_event_ecommerce',
    event_name: 'add_to_cart',
    ...props,
    ecommerce: { ...props.ecommerce, ...getCatalogSourceTrackingData() }
  };

  const result = addToCartEventSchema.safeParse(addToCartEvent);

  if (!result.success) {
    logger.error(result.error, 'Invalid add to cart event');
  }

  return addToCartEvent;
};
